import { render, staticRenderFns } from "./ItemScLNewItem_List.vue?vue&type=template&id=50d9d0b6"
import script from "./ItemScLNewItem_List.vue?vue&type=script&lang=js"
export * from "./ItemScLNewItem_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports